import { z } from '@qred/components-library';

export const requiredString = (refineOptions?: {
  validator: (value: string) => boolean;
  message: string;
}) => {
  const requiredStringSchema = z
    .string()
    .trim()
    .min(1, { message: 'ValidationErrors.Required' });

  if (refineOptions) {
    return requiredStringSchema.refine(refineOptions.validator, {
      message: refineOptions.message,
    });
  }

  return requiredStringSchema;
};
